module.exports = __webpack_public_path__ + "img/HXSelta.596a8301.png";